import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Divider, FormControlLabel, Paper } from '@material-ui/core';
import { Tabs, Typography, Switch } from '@knockrentals/knock-shared-web-v2';
import { DividedTabSection } from '../../TabSections';
import { SECTIONS } from '../../constants';
import {
  HOURS_TAB_LABELS,
  HOURS_TAB_LIST,
  HOURS_TABS,
  OFFICE_TOURING_SAME_LABEL,
  TAB_ICONS,
} from './constants';
import { HoursList } from './HoursList';
import { dayHoursPropType } from './HoursList/constants';
import { makeCss } from '../../../../../../../knock-design-system';

const useCss = makeCss((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    overflow: 'hidden',
    padding: '20px 16px',
  },
  tab: {
    minHeight: '48px',
    textTransform: 'unset',
  },
  tabBar: {
    borderBottom: `1px solid ${theme.palette.slate?.[200]}`,
  },
  officeTouringSameLabel: {
    alignSelf: 'flex-start',
    marginLeft: 0,
    marginRight: 0,
  },
}));

const Hours = ({ hours, onAddHolidayHours, updateHours }) => {
  const css = useCss();
  const [officeAndTouringSame, setOfficeAndTouringSame] = useState(false);
  const [selectedTab, setSelectedTab] = useState(HOURS_TABS.OFFICE);
  const { DESCRIPTION, TITLE } = SECTIONS.HOURS;

  const handleOfficeTouringSameChange = (event) => {
    setOfficeAndTouringSame(event.target.checked);
  };

  const handleOnTabChange = (_e, value) => {
    setSelectedTab(value);
  };

  return (
    <DividedTabSection description={DESCRIPTION} title={TITLE}>
      <Paper css={css.paper} variant="outlined">
        <Tabs
          css={css.tabBar}
          onChange={handleOnTabChange}
          value={selectedTab}
          variant="standard"
        >
          {HOURS_TAB_LIST.map((tab) => {
            const tabIcon = TAB_ICONS[tab];

            return (
              <Tabs.Tab
                css={css.tab}
                icon={tabIcon}
                iconPosition="left"
                key={tab}
                label={HOURS_TAB_LABELS[tab]}
                value={tab}
              />
            );
          })}
        </Tabs>

        <HoursList
          hours={hours}
          onAddHolidayHours={onAddHolidayHours}
          selectedTab={selectedTab}
          updateHours={updateHours}
        />

        <Divider />

        <FormControlLabel
          css={css.officeTouringSameLabel}
          control={
            <Switch
              checked={officeAndTouringSame}
              color="primary"
              id="office-touring-same"
              inputProps={{
                'aria-label': OFFICE_TOURING_SAME_LABEL,
              }}
              onChange={handleOfficeTouringSameChange}
            />
          }
          label={
            <Typography color="textSecondary" variant="body2">
              {OFFICE_TOURING_SAME_LABEL}
            </Typography>
          }
          labelPlacement="start"
        />
      </Paper>
    </DividedTabSection>
  );
};

Hours.propTypes = {
  hours: PropTypes.objectOf(PropTypes.objectOf(dayHoursPropType)).isRequired,
  onAddHolidayHours: PropTypes.func.isRequired,
  updateHours: PropTypes.func.isRequired,
};

export default Hours;
